<template>
	<div class="pages">
		<sub-ibox-title :is-show-back=false><p slot="title">门店管理</p></sub-ibox-title>
		<!--<z-tab-bar :list-obj="tabBarParams.list" :active="tabBarParams.active" @handleClickTabBar = "handleClickTabBar"></z-tab-bar>-->
		<section>
			<shop-manage ref="shopManage"  v-if ="tabBarParams.active =='shopManage'"></shop-manage>
		</section>
	</div>
</template>
<script>
	import ShopManage from "./ShopManage.vue";
	export default {
		name: 'PayManage',
		components: {
			ShopManage
		},
		data() {
			return {
				tabBarParams:{
					list:[{
						title:'门店管理',
						type:'shopManage'
					}],
					active:'shopManage'//默认
				}
			}
		},
		methods: {
//			handleClickTabBar(type) {
//				this.tabBarParams.active = type;
//				this.$refs.shopManage.initData();
//			}
		}
	}
</script>
<style scoped lang="scss">
@import "src/assets/css/common.scss";
.sub-ibox-title{
	/*border-bottom: 0;*/
}
</style>


// WEBPACK FOOTER //
// Index.vue?2b1defb5